import { combineReducers } from '@reduxjs/toolkit';
import { createCustomSlice } from 'store/store.utils';
import { getOrdersListAsyncThunk } from './orders.action';

const ordersListSlice = createCustomSlice(
  'orders/ordersList',
  getOrdersListAsyncThunk
);

export const { reset: resetOrdersList } = ordersListSlice.actions;

export const ordersReducer = combineReducers({
  ordersList: ordersListSlice.reducer,
});
